import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Styles from "./InstoreReq.module.css";
import NoDataFound from "../common/NoDataFound";
import ShimmerLoader from "../../pages/ShimmerLoader/ShimmerLoader";
import currenyFormat from "../common/currentFormat";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { createAcceptReuqestAction, getAllRequests } from "../../../store/actions/InstoreRequest/InstoreRequestActions";

const InstoreRequestList = ({ requests, loading }) => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState('');
  const [timeLeft, setTimeLeft] = useState({});


  const dispatch = useDispatch()

  const handleRequest = (req_id) => {
    setShowModal(true)
    setSelectedRequest(req_id)
  };

  const calculateTimeLeft = (validTill) => {
    const validTillDate = new Date(validTill);
    const now = new Date();
    const diff = validTillDate - now; 

    console.log('minSecs', diff);
    if (diff > 0) {
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);
      return { minutes, seconds };
    } else {
      return null; // Expired
    }
  };

  // Update time remaining every second
  useEffect(() => {
    const interval = setInterval(() => {
      const updatedTimes = {};
      requests.forEach((item) => {
        updatedTimes[item.id] = calculateTimeLeft(item.valid_till);
      });
      setTimeLeft(updatedTimes);
    }, 1000);

    return () => clearInterval(interval); 
  }, [requests]);


  

  return (
    <>
      <div className="card-body">
        <div className="table-responsive ticket-table">
          <div id="ticket_wrapper" className="dataTables_wrapper no-footer">
            <div className="table-responsive">
              <table
                id="example"
                className="display dataTablesCard table-responsive-xl dataTable no-footer w-100"
              >
                <thead>
                  <tr>
                    <th>Request ID</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th>Metal Price/gm</th>
                   
                    <th className="text-center">Expires In</th>
                    <th className="text-center">Action</th>
                    <th className="text-center">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={8} className="text-center">
                        <ShimmerLoader width="95%" height="20%" count={3} />
                      </td>
                    </tr>
                  ) : requests?.length > 0 ? (
                    requests?.map((item, index) => (
                      <tr key={index}>
                        <td
                          // onClick={() => handleRowClick(item.id)}
                          style={{ cursor: "pointer" }}
                        >
                          {item.transaction_ref_id || "--"}
                        </td>
                        <td className="text-center">
                          {item.customer_name || "--"}
                        </td>
                        <td className="text-center">{item.email || "--"}</td>
                        <td className="text-center">{item.phone || "--"}</td>
                        <td className="text-center">{item.quantity || "--"}</td>
                        <td className="text-center">{isNaN(item.total_amount) ? "--"  : item?.total_amount}</td>
                        <td className="text-center">{isNaN(item.price_per_gram) ? "--"  : item?.price_per_gram}</td>
                        
                        <td className="text-center">
                          {" "}
                          {timeLeft[item.id] &&
                          item.status !== "Completed" &&
                          item.status !== "Rejected" ? (
                            <div style={{ color: "red" }}>
                              {timeLeft[item.id].minutes}m{" "}
                              {timeLeft[item.id].seconds}s
                            </div>
                          ) : (
                            "Expired"
                          )}
                        </td>
                        <td
                          onClick={() =>
                            !item.expired ? handleRequest(item.id) : null
                          }
                          className="text-center"
                          style={{ cursor: "pointer", fontWeight: "bold" }}
                        >
                          {!item.expired ? (
                            <div className="btn btn-secondary btn-sm content-icon me-1">
                              <i className="fa fa-edit"></i>
                            </div>
                          ) : (
                            "--"
                          )}
                        </td>
                        <td className="text-center">{item.status || "--"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr className={`${Styles.no_hover}`}>
                      <td className={`fs-3 text-center`} colSpan={8}>
                        <NoDataFound width={450} />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <Modal className="modal" show={showModal}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Enter Details</h5>
            <Button
              variant=""
              type="button"
              className="close"
              data-dismiss="modal"
              onClick={() => setShowModal(false)}
            >
              <span>×</span>
            </Button>
          </div>
          <div className="modal-body">
            <form
              className="comment-form"
              onSubmit={(e) => {
                e.preventDefault();
                console.log(
                  "PAYLOAD",
                  selectedRequest,
                  e.target.referenceId.value
                );
                const status = e.nativeEvent.submitter.value === "Accept";
                const payload = {
                  request_id: selectedRequest,
                  status: status,
                  billing_ref_no: e.target.referenceId.value,
                };
                dispatch(createAcceptReuqestAction(payload, navigate));
                // window.location.reload()
                setSelectedRequest('');
                setShowModal(false);
              }}
            >
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group mb-3">
                    <label htmlFor="author" className="text-black font-w600">
                      {" "}
                      Reference ID <span className="required">*</span>{" "}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="referenceId"
                      placeholder="reference Id"
                    />
                  </div>
                </div>

                <div className="col-lg-12">
                  <div
                    className="form-group mb-3"
                    style={{ display: "flex", gap: 6 }}
                  >
                    <input
                      type="submit"
                      value="Accept"
                      className="submit btn btn-primary"
                      name="submit"
                    />
                    <input
                      type="submit"
                      value="Reject"
                      className="submit btn btn-danger me-3"
                      name="submit"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default InstoreRequestList;
